export const fontSizes = {
  xxs: { value: "0.5rem" }, // 8px
  xs: { value: "0.75rem" }, // 12px
  sm: { value: "0.875rem" }, // 14px
  md: { value: "1rem" }, // 16px
  lg: { value: "1.125rem" }, // 18px
  xl: { value: "1.25rem" }, // 20px
  "2xl": { value: "1.5rem" }, // 24px
  "3xl": { value: "1.563rem" }, // 26px
  "4xl": { value: "1.875rem" }, // 30px
  "5xl": { value: "2.756rem" }, // 44px
  "6xl": { value: "3.125rem" }, // 50px
};
